export const enum LoginResult {
    Success,
    Failure,
    CompletionRequired,
}
